<!-- <div fxxLayout="row" *ngIf="throughput">
    <span fxFlex="1 1 auto" class="liquitics-h5">Expected Pay: {{formatAmount(throughput.expectedPayAmount)}}</span>
    <span fxFlex="1 1 auto" class="liquitics-h5">Expected Rec: {{formatAmount(throughput.expectedRecAmount)}}</span>
    <span fxFlex="1 1 auto" class="liquitics-h5">Authorized Pay: {{formatAmount(throughput.authorizedPayAmount)}}</span>
    <span fxFlex="1 1 auto" class="liquitics-h5">Authorized Rec: {{formatAmount(throughput.authorizedRecAmount)}}</span>
    <span fxFlex="1 1 auto" class="liquitics-h5">Actual Pay: {{formatAmount(throughput.actualPayAmount)}}</span>
    <span fxFlex="1 1 auto" class="liquitics-h5">Actual Rec: {{formatAmount(throughput.actualRecAmount)}}</span>
</div> -->
<div fxLayout="row">
    <p-table *ngIf="throughput" fxFlex="1 1 auto" class="throughput-table liquitics-compact-table" styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
            <tr>
                <th colspan="2">Expected</th>
            </tr>
            <tr>
                <th>
                    <div id="expected-pay">Pay</div>
                </th>
                <th>
                    <div id="expected-rec">Receive</div>
                </th>
            </tr>
            <tr>
                <td class="centered">{{formatAmount(throughput.expectedPayAmount)}}</td>
                <td class="centered">{{formatAmount(throughput.expectedRecAmount)}}</td>
            </tr>
        </ng-template>
    </p-table>
    <p-table *ngIf="throughput" fxFlex="1 1 auto" class="throughput-table liquitics-compact-table" styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
            <tr>
                <th colspan="2">Authorized</th>
            </tr>
            <tr>
                <th>
                    <div id="authorized-pay">Pay</div>
                </th>
                <th>
                    <div id="authorized-rec">Receive</div>
                </th>
            </tr>
            <tr>
                <td class="centered">{{formatAmount(throughput.authorizedPayAmount)}}</td>
                <td class="centered">{{formatAmount(throughput.authorizedRecAmount)}}</td>
            </tr>
        </ng-template>
    </p-table>
    <p-table *ngIf="throughput" fxFlex="1 1 auto" class="throughput-table liquitics-compact-table" styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
            <tr>
                <th colspan="2">Actual</th>
            </tr>
            <tr>
                <th>
                    <div id="actual-pay">Pay</div>
                </th>
                <th>
                    <div id="actual-rec">Receive</div>
                </th>
            </tr>
            <tr>
                <td class="centered">{{formatAmount(throughput.actualPayAmount)}}</td>
                <td class="centered">{{formatAmount(throughput.actualRecAmount)}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
<p-tabView #tabview>
    <p-tabPanel header="Account" fxLayout="column">
        <div fxFlex="1 1 auto" class="chartwrapper liquitics-box">
            <div id="accountdiv" class="chartdiv"></div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Desk" fxLayout="column">
        <ng-container *ngTemplateOutlet="accountFilter"></ng-container>
        <div fxFlex="1 1 auto" class="chartwrapper liquitics-box">
            <div id="deskdiv" class="chartdiv"></div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Product" fxLayout="column">
        <ng-container *ngTemplateOutlet="accountFilter"></ng-container>
        <div fxFlex="1 1 auto" class="chartwrapper liquitics-box">
            <div id="productdiv" class="chartdiv"></div>
        </div>
    </p-tabPanel>
    <p-tabPanel header="Client Group" fxLayout="column">
        <ng-container *ngTemplateOutlet="accountFilter"></ng-container>
        <div fxFlex="1 1 auto" class="chartwrapper liquitics-box">
            <div id="clientgroupdiv" class="chartdiv"></div>
        </div>
    </p-tabPanel>
</p-tabView>
<ng-template #accountFilter>
    <mat-form-field fxFlex="1 1 auto">
        <mat-select placeholder="Accounts" [(ngModel)]="selectedAccounts" multiple (selectionChange)="accountsSelected($event)">
            <!-- <mat-select-trigger>
                {{selectedAccounts ? ((selectedAccounts.length > 0) ? selectedAccounts[0].displayValue : '') : ''}}
                <span *ngIf="selectedAccounts?.length > 1" class="additional-selection">
                    (+{{selectedAccounts.length - 1}} others)
                </span>
            </mat-select-trigger> -->
            <mat-option *ngFor="let option of accounts" [value]="option">
                {{ option.displayValue }}
            </mat-option>
        </mat-select>
        <p-progressBar *ngIf="loading" mode="indeterminate" [style]="{'height': '6px'}" fxFlex="5 5 grow" fxFlexAlign="center"></p-progressBar>
    </mat-form-field>
    <button fxFlex="0 1 auto" mat-icon-button (click)="clearAccountFilter()">
        <mat-icon aria-label="Clear Account Filters">clear</mat-icon>
    </button>
</ng-template>

<!-- <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
            <div id="accountdiv" class="chartdiv"></div>
        </div>
        <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
            <div id="deskdiv" class="chartdiv"></div>
        </div>
        <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
            <div id="productdiv" class="chartdiv"></div>
        </div>
        <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
            <div id="clientgroupdiv" class="chartdiv"></div>
        </div> -->